<template>
    <div class="medal-block">
        <div class="medals">
            <div class="medal bronze" :class="{ won : isType( 'bronze'  ) }"></div>
            <div class="medal silver" :class="{ won : isType( 'silver'  ) }"></div>
            <div class="medal gold"   :class="{ won : isType( 'gold' ) }"></div>
            <div class="medal platinum" :class="{ won : isType( 'platinum'  ) }"></div>
        </div>
        <div class="label">Your Result<strong>{{medalType}}</strong></div>
        <div class="label" v-if="medalLabel !== ''"><strong>{{medalLabel}}</strong></div>
        <p v-html="medalDescription"></p>
    </div>
</template>

<script>
    import slugify from '/src/assets/js/slugify.js'

    export default {
        name : "Medal4",
        props: {
            medalType: String,
            medalKey: String,
            medalDescription: String,
            medalLabel: String
        },
        methods : {
            isType( val ){
                let match = false
                val.split( "," ).forEach( v => {
                    if( slugify( v ) === this.medalKey ){
                        match = true
                    }
                })
                return match
            }
        }
    }
</script>